import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const PlusIconSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2497 7.82213H1.39258M7.82115 1.39355V14.2507"
      stroke="#9448FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={PlusIconSvg} {...props} />
);

export default PlusIcon;

PlusIcon.displayName = "PlusIcon";
